import * as React from 'react';
import styles from './Navbar.module.scss';
import SVG from 'react-inlinesvg';
//assets
import defaultUserImage from '../../assets/icons/ic_avatar_default.svg';
import logo from '../../assets/logo-black-bg.svg';

//tr
import { tr } from '../../utils/translations/translator';
import { useTranslation } from 'react-i18next';

export interface UserNavbarProps {
  userImg: string;
  requestLogout: () => void;
}

export const UserNavbar: React.FC<UserNavbarProps> = (props) => {
  const { t } = useTranslation();
  const { requestLogout, userImg } = props;

  return (
    <>
      <div className={styles.padding}></div>
      <div className={styles.userNavbar}>
        <div className={styles.alignLeft}>
          <div className={styles.navbarLogo}>
            <SVG src={logo}></SVG>
          </div>

          {/* {UserRoutes.map(
            route =>
              route.active && (
                <div className={styles.navbarItem} key={route.key}>
                  <NavLink
                    to={route.path}
                    activeClassName={styles.active}
                    className={styles.nav}
                  >
                    <SVG src={route.svg} />
                  </NavLink>
                </div>
              ),
          )} */}
        </div>

        <div className={styles.alignRight}>
          <img
            src={userImg || defaultUserImage}
            className={styles.avatar}
            alt="user profile pic"
          />

          <div className={styles.logout} onClick={requestLogout}>
            <p>{tr(t, 'logout')}</p>
          </div>
        </div>
      </div>
    </>
  );
};
